import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AppAuthApi } from './app'
import { BackofficeAuthApi } from './backoffice'
import { Queue } from '../../queue'

export class AuthApp implements ApiAppNamespaces {
  app: AppAuthApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppAuthApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class AuthBackoffice implements ApiBackofficeNamespaces {
  backoffice: BackofficeAuthApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new BackofficeAuthApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
